export default __webpack_public_path__ + "static/media/sonicmovers-logo.88a5b26f.webp";